import { FC, useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import { Exclusion } from '../types/exclusion-types';
import { removePolicyExclusion } from '../actions/exclusions-actions';
import { useSnapshot } from 'valtio';
import ExclusionsStore from '../stores/exclusions-store';
import { setModalAction } from '../store-actions/exclusions-store-actions';
import ButtonGroup from '../../common/components/ButtonGroup';

const handleCancel = () => {
  setModalAction(false);
};
const EnablePolicyContent: FC<
  React.PropsWithChildren<EnablePolicyContentProps>
> = ({ exclusion }) => {
  const { isRemoveExclusionLoading } = useSnapshot(ExclusionsStore);

  const handleClick = useCallback(() => {
    removePolicyExclusion({
      policyName: exclusion.policyName,
      exclusionId: exclusion.exclusionId,
    });
  }, [exclusion]);

  return (
    <Box>
      <Typography variant='body1' mb={1}>
        Would you like to re-enable policy "{exclusion.policyName}"? Please note
        that a new scan will be needed for issues related to the policy to
        appear.
      </Typography>

      <Box display='flex' alignItems='end'>
        <ButtonGroup
          onCancel={handleCancel}
          onClick={handleClick}
          buttonCancelLabel='Cancel'
          buttonCancelTooltip='Cancel'
          buttonActionLabel='Enable Policy'
          buttonActionTooltip='Click to enable policy'
          isLoading={isRemoveExclusionLoading}
          isActionDisabled={false}
        />
      </Box>
    </Box>
  );
};

export interface EnablePolicyContentProps {
  exclusion: Exclusion;
}

export default EnablePolicyContent;
